import React from "react";
import {JSON_HEADERS} from "../constants/constants";

export function postingResponse(type) {
    return ( type == 'question' ? 'answer' : 'comment' );
}

export function commentIcon(type) {
    return ( type == 'question' ? 'reply' : 'message' );
}

export function newCommentPlaceholder(type) {
    switch(type) {
        case 'question':
            return 'Write your answer...';
        case 'comment':
            return 'Reply...';
        default:
            return `Share your thoughts on this ${sanitizeType(type)}...`;
    }
}

export function newPostPlaceholder(type) {
    switch(type) {
        case 'question':
            return 'Post a question';
        default:
            return 'Share your thoughts about a topic or product';
    }
}

export function newCommentFormData(type) {
    switch(type) {
        case 'Comment':
            return { url: '/comments', parent_key: 'posting_id'}
        case 'Reply':
            return { url: '/replies', parent_key: 'comment_id'}
    }
}

export function sanitizeType(type) {
    return (type == 'product_review') ? 'review' : type;
}

export function sanitizeRedactorContent(html) {
    // removes unwanted empty paragraphs and line returns inserted by redactor
    return html.replace(/(((<\w+>)+[ \\n(<br>)]*(<\/\w+>)+)+)|<br><br>|<p>\\n<\/p>|\\n/g, '');
}

export async function fetchReviews(reviewIds, includeData='display_data,filter_data') {
    let data = { include_data: includeData, review_ids: reviewIds };

    const response = await fetch('/product_reviews/presenter_data', {
        method: 'POST',
        headers: JSON_HEADERS,
        body: JSON.stringify(data)
    });

    const jsonResponse = await response.json();
    return jsonResponse.reviews;
}

export async function updateReviewAccessCount(token) {
    await fetch('/review_access', {
        method: 'POST',
        headers: JSON_HEADERS,
        body: JSON.stringify({ authenticity_token: token})
    });
}